import * as v from 'valibot';

import type { HistAircraftLocation } from '../types';

export const histAircraftLocationSchema: v.GenericSchema<HistAircraftLocation> =
  v.object({
    Longitude: v.number('Longitude is missing'),
    Latitude: v.number('Latitude is missing'),
    Heading: v.number('Heading is missing'),
    LocationTimestamp: v.string('Location timestamp is missing'),
  });
